/* claude 购物车抽屉：Check out 下面补「View cart」文字链接（snippets/claude-cart-drawer-extras.liquid）
   Dawn 加购、改数量后会整块替换抽屉的内容（#CartDrawer / .drawer__inner 的 innerHTML），
   这里用 MutationObserver 在每次替换后把链接补回去；已经有了就不动。抽屉是空的（没有 Check out）时不加。 */
(function () {
  if (window.claudeCartDrawerReady) return;
  window.claudeCartDrawerReady = true;

  function init() {
    var cfg = document.getElementById('ClaudeCartDrawerCfg');
    var drawer = document.getElementById('CartDrawer');
    if (!cfg || !drawer) return;
    var label = cfg.getAttribute('data-label');
    var url = cfg.getAttribute('data-url');
    if (!label || !url) return;

    function ensure() {
      var ctas = drawer.querySelector('.drawer__footer .cart__ctas');
      if (!ctas) return;
      var next = ctas.nextElementSibling;
      if (next && next.classList.contains('claude-cart-viewcart')) return;
      var link = document.createElement('a');
      link.className = 'claude-cart-viewcart';
      link.href = url;
      link.textContent = label;
      ctas.insertAdjacentElement('afterend', link);
    }

    ensure();
    new MutationObserver(ensure).observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
